import type { CollectionRequestForm, ExpectedDateTimeValidation } from '@/views/CollectionRequest/const';
import http from '../http';
import type { CollectionDates } from '@/views/CollectionSchedule/const';

export interface CRequestFilterRequest {
  filterName: string;
  filterValue: string | null;
}

export interface CollectionDateVerification  {
  cRequestId:number;
  projectId:string;
  date: string;
  wasteIds: number[];
  typeCheck: string;
}

export interface RecentCollectedRequestResponse {
	collectionStartDate: string;
	collectionEndDate: string;
  isAllDay: boolean;
	repeatType: string;
}

export interface CollectionScheduleDatesDto {
    registeredStartDate: string | null;
    registeredEndDate: string | null;
    isAllDay: boolean;
    repeatType: string;
    cRequestId: number;
}

export const createOrUpdateCollectionRequest = (crequest: CollectionRequestForm) => 
  http.post('/crequests', crequest);

export const getCollectionRequestByUserId = () => 
  http.get(`/crequests/user`,{ returnFullResponse: true });


export const getProjectsForCollectionRequest = () => 
  http.get(`/crequests/projects`);

export const getNotCollectedDates = () =>
  http.get('/crequests/not-collected-dates');

export const getProjectContractRange = (projectId: String) =>
  http.get(`/crequests/contract-range/${projectId}`);

export const confirmCollectionRequest = (crequestId: number) => 
  http.put(`/crequests/${crequestId}/confirm`);

export const getCollectionRequests = (crequestFilters: CRequestFilterRequest[]) => {
  return http.post('/crequests/filter',crequestFilters)  
}

export const getCollectionRequestsForTrans = (crequestFilters: CRequestFilterRequest[], companyId: number) => {
  const params = companyId !== undefined ? `?companyId=${companyId}` : '';
  return http.post(`/trans/crequests/filter${params}`, crequestFilters);
}


export const getCollectionRequestById = (crequestId:number) => {
  return http.get(`/crequests/${crequestId}`)  
}

export const updateDesiredCollectionDate = (crequestId: number,dates:CollectionDates) => {
  return http.put(`/crequests/${crequestId}/desired-date`,dates)
}

export const updateRegisterdCollectionDate = (crequestId: number,dates:CollectionDates) => {
  return http.put(`/crequests/${crequestId}/registed-date`,dates)
}

export const deleteCollectionDate = (id: number, shouldProcessAll: boolean) => {
  return http.delete(`/crequests/${id}`, {
    params: { shouldProcessAll }
  });
};


export const verifyCollectionDate = ( collectionDateVerification : CollectionDateVerification) =>{
  return http.post('/crequests/verify-date', collectionDateVerification)
}

export const getRecentCollectedRequestsByProjectId = (projectId: string) =>
	http.get<RecentCollectedRequestResponse[]>(`/crequests/project/${projectId}/recent-collected`);

export const registerCollectionRequests = (collectionScheduleDatesDto: CollectionScheduleDatesDto[]) =>
    http.post('/crequests/register', collectionScheduleDatesDto);

export const printCollectionRequests = (cRequestIdList: number[]) =>
    http.post('/crequests/print', cRequestIdList, {responseType: 'blob', returnFullResponse: true});
